// IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): страница «Tasks & Workspace settings»
// (page-settings) больше не строка списка страниц стола — бэк снимает её со стола и отдаёт администратору шаблон WORKSPACE.settings_page (PAGE той же
// формы, что элементы WORKSPACE.PAGES: page, node.valueStr, pi, attrs с 'more' → запись стола onOpening; без ind). Пункт в начале меню задач (AppTopbar)
// и прямой адрес …&page=page-settings (закладка, личный дефолт, workspace_goto) МАТЕРИАЛИЗУЮТ её: клон шаблона кладётся в PAGES последней страницей
// (перед служебной «+» page-new — как временная страница плитки «+», Page.checkNewPage), с пометкой _temp = 'settings' (store.page_isTemp: ⚙ / Save (page)
// недоступны, «+» / «✓» — Save as new page). В запись стола она не попадает (форма стола читает запись из БД заново) и пропадает при переоткрытии стола.
// Страница ещё в столе (бэк её не снял) — пункт просто открывает её. Выключатель fe.ux.settingsPageInMenu = false — пункта нет и материализации нет.
// Чистые функции; юнит — tests/unit/settingsPage.test.mjs.
export const SETTINGS_PAGE_ID = 'page-settings'
export const SETTINGS_PAGE_PI = 'pi pi-sitemap'
export const SETTINGS_PAGE_FLAG = 'fe.ux.settingsPageInMenu'
export const SETTINGS_PAGE_PLUS = 'page-new'

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const num = (x) => (typeof x === 'number' && Number.isFinite(x)) ? x : null
// копия шаблона: ответ бэка — JSON (через JSON и реактивный прокси стора копируется без ссылок на оригинал)
const clone = (x) => JSON.parse(JSON.stringify(x))

// выключатель: store.setting(key, default) либо ничего (по умолчанию вкл)
export function settingsPage_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(SETTINGS_PAGE_FLAG, true) === false) } catch (e) { return true }
}

// пункт меню есть: шаблон бэка или страница ещё в списке страниц стола
export function settingsPage_available(WS) {
    return !!(WS && (isObj(WS.settings_page) || isObj(WS.PAGES?.[SETTINGS_PAGE_ID])))
}

// название пункта — название страницы (бэк локализует valueStr / title), иначе fallback
export function settingsPage_title(WS, fallback = '') {
    const P = (WS && (WS.PAGES?.[SETTINGS_PAGE_ID] || WS.settings_page)) || null
    return String((P && (P.title || P.node?.valueStr)) || fallback || '')
}

// временная страница настроек (клон шаблона), а не строка списка страниц стола
export function settingsPage_isTemp(WS, page) {
    return String(page ?? '') === SETTINGS_PAGE_ID && WS?.PAGES?.[SETTINGS_PAGE_ID]?._temp === 'settings'
}

// материализация: страница уже в PAGES — true без изменений; иначе клон шаблона WS.settings_page в PAGES последней (ind служебной «+»; «+» сдвигается на
// одну позицию, как в Page.checkNewPage); группа страниц у клона снимается (страница — отдельной плиткой в конце). false — шаблона нет
export function settingsPage_materialize(WS) {
    if (!WS || !isObj(WS.PAGES)) return false
    if (isObj(WS.PAGES[SETTINGS_PAGE_ID])) return true
    if (!isObj(WS.settings_page)) return false
    const P = clone(WS.settings_page)
    P.page = SETTINGS_PAGE_ID
    P.node = { ...(isObj(P.node) ? P.node : {}), value: SETTINGS_PAGE_ID }
    if (!P.node.pi) P.node.pi = P.pi || SETTINGS_PAGE_PI
    delete P.group
    delete P.badge
    P._temp = 'settings'
    const plus = WS.PAGES[SETTINGS_PAGE_PLUS]
    if (isObj(plus) && num(plus.ind) !== null) {
        P.ind = plus.ind
        P.show_index = num(plus.show_index) !== null ? plus.show_index : plus.ind
        plus.ind = plus.ind + 1
        if (num(plus.show_index) !== null) plus.show_index = plus.show_index + 1
    } else {
        const inds = Object.values(WS.PAGES).map(x => num(x?.ind)).filter(x => x !== null)
        P.ind = inds.length ? Math.max(...inds) + 1 : 0
        P.show_index = P.ind
    }
    WS.PAGES[SETTINGS_PAGE_ID] = P
    return true
}

// страница маршрута: запрошена страница настроек и её удалось материализовать — она, иначе fallback (как решил бэк / роутер)
export function settingsPage_pick(WS, requested, fallback) {
    return (String(requested ?? '') === SETTINGS_PAGE_ID && settingsPage_materialize(WS)) ? SETTINGS_PAGE_ID : fallback
}

export default { SETTINGS_PAGE_ID, SETTINGS_PAGE_PI, SETTINGS_PAGE_FLAG, settingsPage_on, settingsPage_available, settingsPage_title, settingsPage_isTemp, settingsPage_materialize, settingsPage_pick }
